import React from 'react';
import * as S from './PaintColourDesktopControls.style';
import { motion } from 'framer-motion';
import { Loader, useStyles } from '@archipro-design/aria';
import { ResenePickColour, Trash } from '@archipro-design/icons';
import { usePaintPickerContext } from '@modules/paint-picker-new/context/PaintPickerContext';

interface PaintColourDesktopControlsProps {
    top: number;
    onMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const PaintColourDesktopControls = ({
    top,
    onMouseLeave,
}: PaintColourDesktopControlsProps) => {
    const {
        state: { isPicking, selectedColorIndex, isAddingToCart },
        paintSelection,
        setPickingProcess,
        addPaintToCart,
        removePaint,
        goToProductPage,
    } = usePaintPickerContext();

    const selectedPaintColour =
        selectedColorIndex !== null
            ? paintSelection[selectedColorIndex] ?? null
            : null;

    const isReplacingColour = isPicking && selectedColorIndex !== null;

    const { css } = useStyles({ top, isAddingToCart });

    return selectedPaintColour ? (
        <motion.div
            key={selectedPaintColour.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, x: 10 }}
            className={`${css(S.Container)} paint-controls`}
            onMouseLeave={onMouseLeave}
        >
            {isReplacingColour ? (
                <div
                    className={css(S.Button)}
                    onClick={() => setPickingProcess(false)}
                >
                    Cancel Replacement
                </div>
            ) : (
                <>
                    {selectedPaintColour.variantId ? (
                        <div
                            className={css(S.Button, S.ButtonLoader)}
                            onClick={() => addPaintToCart(selectedPaintColour)}
                        >
                            <span>
                                {isAddingToCart ? (
                                    <Loader size="smallest" />
                                ) : (
                                    'Get Sample'
                                )}
                            </span>
                        </div>
                    ) : selectedPaintColour.link ? (
                        <div
                            className={css(S.Button)}
                            onClick={() => goToProductPage(selectedPaintColour)}
                        >
                            <span>View Details</span>
                        </div>
                    ) : null}

                    <div
                        className={css(S.Button)}
                        onClick={() => setPickingProcess(true)}
                    >
                        <div className={css(S.ReplaceButtonIcon)}>
                            <ResenePickColour />
                        </div>
                        <span>Replace</span>
                    </div>

                    <div
                        className={css(S.Button, S.DeleteButton)}
                        onClick={() => removePaint(selectedPaintColour.id)}
                    >
                        <Trash className={css(S.DeleteButtonIcon)} />
                    </div>
                </>
            )}
        </motion.div>
    ) : null;
};
